var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_123_1721)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    transform: "matrix(1 0 0 -1 0 44)",
    fill: "#CECECE",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0021 18.9077L15.694 25.4308C15.2265 25.9137 14.4725 25.9137 14.005 25.4308C13.7817 25.2008 13.656 24.887 13.656 24.5597C13.656 24.2324 13.7817 23.9186 14.005 23.6885L21.1564 16.2942C21.6234 15.8099 22.3784 15.8099 22.8454 16.2942L29.9968 23.6882C30.2201 23.9186 30.3457 24.2324 30.3457 24.5597C30.3457 24.887 30.2201 25.2008 29.9968 25.4312C29.5292 25.9137 28.7752 25.9137 28.3078 25.4305L22.0021 18.9077Z",
    fill: "#0060FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0021 18.9077L15.694 25.4308C15.2265 25.9137 14.4725 25.9137 14.005 25.4308C13.7817 25.2008 13.656 24.887 13.656 24.5597C13.656 24.2324 13.7817 23.9186 14.005 23.6885L21.1564 16.2942C21.6234 15.8099 22.3784 15.8099 22.8454 16.2942L29.9968 23.6882C30.2201 23.9186 30.3457 24.2324 30.3457 24.5597C30.3457 24.887 30.2201 25.2008 29.9968 25.4312C29.5292 25.9137 28.7752 25.9137 28.3078 25.4305L22.0021 18.9077Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_123_1721",
    x: -180,
    y: -180,
    width: 404,
    height: 404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 90
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_123_1721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_123_1721",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUpArrow);
export default __webpack_public_path__ + "static/media/circle-up-arrow.87ed59fbbcf89a604b6bae99f250d968.svg";
export { ForwardRef as ReactComponent };